import React, { useEffect, useRef } from "react";
import AboutBanner from "../components/About/AboutBanner";
import WhyWeAre from "../components/About/WhyWeAre";
import AboutVideo from "../components/About/AboutVideo";
import Timeline from "../components/About/Timeline";
import GetINTouch from "../components/Contactus/GetINTouch";
import AboutpageBanner from "../components/About/AboutpageBanner";
import { useLocation } from "react-router-dom";
import gsap from "gsap";
import top_img from "../assets/images/home-page/Reception.png";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
export default function AboutPage() {
  const { hash } = useLocation();
  const imgContainerRef = useRef(null);
  const hospitalImgRef = useRef(null);
  useEffect(() => {
    const topImage = imgContainerRef.current;
    const hospitalImage = hospitalImgRef.current;
    gsap.to(topImage, {
      width: "100%",
      borderRadius: "0px", marginTop:"0rem",
      ease: "none",
      scrollTrigger: {
        trigger: topImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    gsap.to(hospitalImage, {
      width: "100%",
      borderRadius: "0px", marginTop:"0rem",
      ease: "none",
      scrollTrigger: {
        trigger: hospitalImage,
        start: "top 50%",
        end: "+=300",
        scrub: true,
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);
  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 180; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <title>
        Medical Center Diagnostic Imaging | Citrus Diagnostic Center
      </title>
      <meta
        name="description"
        content="At Citrus Diagnostic Center, we provide diagnostic radiology and imaging services using advanced diagnostics imaging technology for accurate health insights."
      />
      <AboutpageBanner />
      <AboutBanner />
      <AboutVideo />
      <Timeline />
      <WhyWeAre />
      <div className="bg-[#f9f9f9] w-full flex justify-center items-center overflow-hidden">
        <div
          ref={imgContainerRef}
          style={{ width: "60%", borderRadius: "24px", marginTop:"4rem" }}
          className="overflow-hidden mx-auto bg-[#f9f9f9]"
        >
          <img src={top_img} alt="Hospital view Showing Reception" className="object-contain w-full " />
        </div>
      </div>

      {/* <GetINTouch /> */}
      <div className="xl:pt-[10rem] xl:pb-[17.6rem] md:py-[8rem] lg:py-[12rem] py-[4rem]  relative text-center bg-[#f9f9f9] ">
        <div className="w-full">
          <div className="px-[2.5rem] w-full mx-auto block ">
            <div className="py-[.5rem]">
              <h2 className="text-5xl sm:text-5xl md:text-7xl text-[#1d1d1f]  xl:text-[10.25rem] lg:leading-[0.9] font-robout font-black tracking-[-.05em] lowercase  ">
                <span
                  data-aos="fade-left"
                  data-aos-delay="100"
                  className="lg:-ml-[3.5rem]"
                >
                  {" "}
                  We are just{" "}
                </span>
                <br />
                <span className="lg:-ml-[2.5rem] flex items-center lg:my-4 xl:my-0 gap-6 justify-center">
                  <span data-aos="fade-right"> a message </span>
                  <Link
                    data-aos="fade-right"
                    to="/contact"
                    aria-label="Contact"
                    className="group relative hidden lg:inline-flex h-14   tracking-widest  items-center rounded-full px-6 py-10  text-sm md:text-[1.5rem] font-semibold  bg-transparent overflow-hidden"
                  >
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                      <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                        <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      </span>
                    </span>
                    <span className="relative">
                      <span className="flex flex-row gap-2 justify-center  items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)] text-[#ffffff]">
                        Get in Touch
                      </span>
                      <span className="absolute flex flec-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)] text-[#ffffff]">
                        Get in Touch
                      </span>
                    </span>
                  </Link>{" "}
                </span>
                <span
                  data-aos="fade-left"
                  data-aos-delay="100"
                  className="lg:ml-[7.3rem]"
                >
                  {" "}
                  away!
                </span>
                <br />
              </h2>
              <Link
                to="/contact"
                aria-label="Contact"
                className="group relative lg:hidden inline-flex h-14  mt-8 font-robout font-black tracking-wider  items-center rounded-full px-6 py-6  text-lg md:text-2xl  text-white bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center  items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)] text-[#ffffff]">
                    Get in Touch
                  </span>
                  <span className="absolute flex flec-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)] text-[#ffffff]">
                    Get in Touch
                  </span>
                </span>
              </Link>{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


//#000000b8   #000000e0